import t from"./_getMapData.js";var a=t;var e=function(t){var e=a(this,t).delete(t);return this.size-=e?1:0,e};export{e as default};
//# sourceMappingURL=_mapCacheDelete.js.map
